export default __webpack_public_path__ + "static/media/poker.67c414c7.png";